/*
Copyright (c) 2024, HP Development Company, L.P. All rights reserved.
This software contains confidential and proprietary information of HP.
The user of this software agrees not to disclose, disseminate or copy
such Confidential Information and shall use the software only in accordance
with the terms of the license agreement the user entered into with HP.
*/

import React, { memo } from 'react';
import './styles.scss';
import { ContainerProps } from './types';

/**
 * UI Toolkit : Section list container
 * @public
 */

const TSectionListContainer: React.FC<ContainerProps> = ({
  children,
  paddingStart = false,
  paddingEnd = false
}) => {
  return (
    <div
      className={`clientos-ui-toolkit-section-list-container ${paddingStart ? 'padding-start' : ''} ${paddingEnd ? 'padding-end' : ''}`}
    >
      {children}
    </div>
  );
};

export default memo(TSectionListContainer);
